import type {CourseApiModel} from '../../../api/course';
import type {ClientTaskApiModel, CoachTaskApiModel} from '../../../api/task';
import type {Nullable} from '../../utility-types';

import {currentUserStore} from '../../../api/user';
import {isNullish} from '../../typecheck';
import {isCourseEditable} from '../course';
import {isMeCoachForEntity} from '../isMeCoachForEntity';
import {isClientTask} from './isTask';
import {isTaskCanBeDone} from './isTaskCanBeDone';

type Action = 'complete' | 'delete' | 'edit';

type Task = ClientTaskApiModel | CoachTaskApiModel;

type TaskExpandedWithCourse = Task & {course?: Nullable<CourseApiModel>};

export function getTaskActions(task?: Nullable<TaskExpandedWithCourse>) {
  const {user} = currentUserStore;

  const actions: Action[] = [];

  if (isNullish(user) || isNullish(task)) {
    return actions;
  }

  if (isCourseEditable(task.course)) {
    if (isMeCoachForEntity(task)) {
      actions.push('edit');
      actions.push('delete');
    } else if (isClientTask(task)) {
      if (isTaskCanBeDone(task)) {
        actions.push('complete');
      }
    }
  }

  return actions;
}
